import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function EmployeeDashboardDetailSheet({
  isOpen,
  title,
  summary,
  eyebrow = 'Stat detail',
  icon = null,
  iconClassName = 'bg-slate-50 text-slate-700 ring-slate-200',
  footer = null,
  maxWidthClassName = 'sm:max-w-2xl',
  onClose,
  children,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      data-testid="employee-dashboard-detail-sheet"
      className="fixed inset-0 z-[9990] flex items-end justify-center bg-slate-950/60 p-3 backdrop-blur-sm sm:items-center"
    >
      <button
        type="button"
        className="absolute inset-0 h-full w-full cursor-default"
        onClick={onClose}
        aria-label="Close detail popup backdrop"
      />
      <div
        data-testid="employee-dashboard-detail-sheet-panel"
        className={`relative flex max-h-[86vh] w-full max-w-md flex-col overflow-hidden rounded-[28px] bg-white shadow-2xl ${maxWidthClassName}`}
      >
        <div className="flex items-start justify-between gap-4 border-b border-slate-100 px-5 py-4">
          <div className="flex min-w-0 items-start gap-3">
            {icon && (
              <div
                data-testid="employee-dashboard-detail-sheet-icon"
                className={`mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ring-1 ${iconClassName}`}
              >
                {icon}
              </div>
            )}
            <div className="min-w-0">
              <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-blue-600">{eyebrow}</p>
              <h3 className="mt-1 truncate text-xl font-black text-slate-950">{title}</h3>
              {summary && <p className="mt-1 text-sm font-medium text-slate-500">{summary}</p>}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-sm hover:bg-slate-50 hover:text-slate-950"
            aria-label="Close detail popup"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5">
          {children}
        </div>

        {footer && (
          <div className="flex-shrink-0 border-t border-slate-100 bg-slate-50 px-5 py-4">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
